<style>
.btn-img-edit{
  position: absolute;
  top: 93px;
  left:93px;
}
</style>

<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base">
                        <div class="relative">
                          <vs-avatar :src="logo" size="120px" />
                          <input type="file" id="file" ref="file" @change="handleFileUpload()" class="hidden"/>
                          <vs-button radius color="primary" type="filled" icon="add" @click="$refs.file.click()" class="btn-img-edit"/>
                        </div>
                        <div class="flex">
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.Name')" :placeholder="$t('Labels.Name')" v-model="data.name"/>
                          </div>
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.Address')" :placeholder="$t('Labels.Address')" v-model="data.address"/>
                          </div>
                        </div>
                        <div class="flex">
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.ContactName')" :placeholder="$t('Labels.ContactName')" v-model="data.contact_name"/>
                          </div>
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.PhoneNumber')" :placeholder="$t('Labels.PhoneNumber')" v-model="data.phone_number" v-mask="'###-###-##-##'"/>
                          </div>
                        </div>
                        <div class="text-right">
                          <vs-button @click="requestPassword()" class="bg-primary mt-4" type="filled" :disabled="!valid">{{$t("Labels.Save")}}</vs-button>
                        </div>
                    </vx-card>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    vSelect
  },

  data () {
    return {
      uuid: this.$route.params.uuid,
      data:{
        name: '',
        address: '',
        contact_name: '',
        phone_number: '',
        file:''
      },
      logo: '',
      file: ''
    }
  },

  methods: {
    requestPassword () {
      globalPassActions.show()
    },
    async add () {
      const form = new FormData()
      form.append('file', this.file)
      form.append('name', this.data.name)
      form.append('address', this.data.address)
      form.append('contact_name', this.data.contact_name)
      form.append('phone_number', this.data.phone_number.replaceAll('-', ''))
      const params = {
        url: 'companies',
        method: 'POST',
        params: form
      }
      await request(params).then(response => {
        this.data = response.data.data
        window.location.href = '/organizations'
      })       
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      const reader = new FileReader()

      // Leemos el archivo subido y se lo pasamos a nuestro fileReader
      reader.readAsDataURL(this.$refs.file.files[0])

      // Le decimos que cuando este listo ejecute el código interno
      const app = this
      reader.onload = function () {
        app.logo = reader.result
      }
    }
  },
  created () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.Companies')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Add')
    this.$route.meta.pageTitle = this.$t('Path.Add')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    },
    valid () {
      if (!empty(this.data.name) && !empty(this.data.address) && !empty(this.data.contact_name) && !empty(this.data.phone_number)) return true
      else return false
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.add()
    }
  }
}
</script>
